import { api } from '../../services/api';

//INTERFACE DE Celula
export interface ICell {
    attributes: {
        x: string;
        y: string;
        solution: string;
    }
}

//INTERFACE DE Palavra
export interface IWord {
    attributes: {
        x: string;
        y: string;
        id: string;
        solution: string;
    }
}

//INTERFACE DE Cola
export interface IClue {
    text: string;
    attributes: {
        word: string;
    }
}

//INTERFACE DE DAdos do game
export interface IHuntWord {
    grid: {
        cell: ICell[],
        attributes: {
            width: string,
            height: string,
        }
    },
    word: IWord[],
    clues: {
        clue: IClue[],
    }
}

export interface LayoutProps {
    x: number,
    y: number,
    height: number,
    width: number,
}

//INTERFACE Do caminho para pegar dados do game
export interface IHuntWordData {
    "crossword-compiler": {
        "rectangular-puzzle": {
            attributes: {
                xmlns: string,
                alphabet: string,
            },
            "word-search": IHuntWord
        }
    }
}

//INTERFACE DE retorno da api
export interface IHuntWordRes {
    id: number;
    id_jogo: number;
    texto: string;
    title?: string;
    game: IHuntWordData;
    created_at: string;
    updated_at: string;
}

//INTERFACE DE soluçoes
export interface ISolution {
    x: string[];
    y: string[];
    id: number;
    solution: string;
    wordId: number; // ID para busca na array do texto
  }


export interface ErrorTrail {
    action: boolean;
    msg: string;
}

////////////////////////FUNCOES DE API

export const getGameById = async (id: number): Promise<IHuntWordRes> => {
    try {
        let response = await api.get<IHuntWordRes>('/show_wordsearch/' + id);
        return response.data;
    } catch (error) {
        throw error;
    }
}
